export default "__VITE_ASSET__RTe1ZVq9__"